import * as React from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';


// Define the props interface
interface SecuritiesDatePickerProps extends Omit<DatePickerProps<Dayjs, Dayjs>, 'value' | 'onChange' | 'renderInput'> {
    label?: string;
    value: Dayjs | null;
    onChange: (date: Dayjs | null) => void;
    InputLabelProps?: any;
    style?: React.CSSProperties;
}

const SecuritiesDatePicker: React.FC<SecuritiesDatePickerProps> = ({ label, value, onChange, InputLabelProps, style, ...props }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                value={value}
                onChange={onChange}
                renderInput={(params) => 
                    <TextField 
                        {...params} 
                        required 
                        variant='filled' 
                        style={{
                            minWidth: '200px',
                            ...style
                        }}
                        InputLabelProps={{ 
                            ...params.InputLabelProps, 
                            ...InputLabelProps,
                            style: {
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: '#333',
                                ...params.InputLabelProps?.style,
                                ...InputLabelProps?.style
                            }
                        }} 
                    />
                }
                {...props}
            />
        </LocalizationProvider>
    );
};


export default SecuritiesDatePicker;
